import React, { Component } from 'react';

import List from "../common/List";
import ProductListItem from '../common/ProductListItem';
import {FormattedMessage} from "react-intl";

class SearchPage extends Component {

	/**
	 * Load the products on first mount
	 */
	componentWillMount(){
		this.props.loadProducts();
	}

	/**
	 * Load other products if the route is changed
	 * @param nextProps - the props that will be received next
	 */
	componentWillReceiveProps(nextProps) {
		if(this.props.match.url !== nextProps.match.url) {
			nextProps.loadProducts();
		}
	}

	/**
	 * Render one product item
	 *
	 * @param product - one product to be rendered
	 * @returns {XML}
	 */
	renderProductList = (product) => {
		const {localizePath} = this.props;
		return (
			<ProductListItem
				key={product.id}
				product={product}
				localizePath={localizePath}
			/>
		);
	};

	/**
	 * Render ProductPage
	 *
	 * @returns {XML}
	 */
	render() {
		const {page, products} = this.props;
		return (
			<div className="container-flex">
				<h2 className={page.titleClass}>
					<FormattedMessage id={"page.title." + page.title.toLowerCase().replace(" ","-")} />
				</h2>
				<div className="page">
					<div className={page.contentClass}>
						<List
							className="product-list product-list--main-page"
							items={products.sort((a,b) => a.name.localeCompare(b.name)).map(this.renderProductList)}/>
					</div>
				</div>
			</div>
		);
	}
}

export default SearchPage;


// WEBPACK FOOTER //
// ./src/components/page/SearchPage.js